import User from "@/components/User/User";

const AthleteProfile: React.FC = () => {
  return <User />;
};

export default AthleteProfile;
